import { throttle } from 'lodash'

$('.boxy10.-lists').each((i, e) => {
    let $boxy = $(e)
    let $box = $boxy.find('.boxy10-lists')
    let $trigger = $boxy.find('.boxy10-trigger')
    let firstFourListItemsHeight, boxHeight

    if ($trigger.length) {
        let triggerText = $trigger.text()
        let triggerTextCollapsed = $trigger.data('collapsed')

        $trigger.click(() => {
            $box.toggleClass('-collapsed')

            if ($box.hasClass('-collapsed')) {
                $box.css('height', boxHeight + 'px')
                $trigger.text(triggerTextCollapsed)
            } else {
                $box.css('height', firstFourListItemsHeight + 'px')
                $trigger.text(triggerText);
            }
        });
    }

    $(window).on('resize', throttle(() => {
        let $firstList = $boxy.find('.boxy10-list:first')
        let $secondList = $firstList.siblings('.boxy10-list')

        $boxy.find('li').removeAttr('style')
        $box.removeAttr('style')

        boxHeight = $box.outerHeight() + 20;

        let isWideEnough = window.matchMedia
            && window.matchMedia('(min-width: 992px)').matches

        if (isWideEnough) {
            $firstList.children().each((i, e) => {
                let $listItem = $(e)
                let $siblingListItem = $secondList.find('[data-index="' + i + '"]')

                if ($siblingListItem.length) {
                    let listItemHeight = $listItem.outerHeight()
                    let siblingListItemHeight = $siblingListItem.outerHeight()
                    let biggestHeight = listItemHeight > siblingListItemHeight
                        ? listItemHeight
                        : siblingListItemHeight

                    $listItem.css('height', biggestHeight + 'px')
                    $siblingListItem.css('height', biggestHeight + 'px')
                }
            })
        }

        firstFourListItemsHeight = 0;

        $firstList.find('li:lt(4)').each((i, e) => {
            firstFourListItemsHeight += $(e).outerHeight() - 1
        });

        if ($box.hasClass('-collapsed')) {
            $box.css('height', boxHeight + 'px')
        } else {
            $box.css('height', firstFourListItemsHeight + 'px')
        }
    }, 100)).trigger('resize')
})